import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TOOL_CHECKOUTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TOOL_CHECKOUTS');
export const TOOL_CHECKOUTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	TOOL_CHECKOUTS_CRUD_ACTION_CONSTANTS
);
